export default "__VITE_ASSET__B7HO1col__"